module.exports = "<p>\r\n  awsop-lab15 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab15/awsop-lab15.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab15/awsop-lab15.component.html
// module chunks = main